<template>
  <b-col
    lg="4"
    xl="3"
    class="text-center"
  >
    <!-- Logo -->
    <p
      aria-hidden="true"
      class="text-center"
    >
      <a
        :href="$t(`partners.${partner}.link`)"
        :title="$t(`partners.${partner}.title`)"
      >
        <img
          :src="`${$t('baseurl')}img/sponsors/${$t(`partners.${partner}.img`)}`"
          :alt="$t(`partners.${partner}.title`)"
        />
      </a><br />
    </p>
  </b-col>
</template>

<script>
export default {
  filters: {
    localeDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(undefined, {
        year: 'numeric', month: 'long', day: 'numeric',
      });
    },
  },
  props: {
    partner: {
      type: String,
      required: true,
    },
  },
  methods: {
    trimHost(url) {
      return url.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '');
    },
  },
};
</script>
